<template>

    <div class="user">
    
  
      
        <div style="border: 1px solid #f7f7f7;float: left;height: 550px;overflow-y: auto;padding: 10px; ">
          <el-form :inline="true" size="small"  class="demo-form-inline">
         
            <el-form-item >
              <el-input style="width: 45%;float: left;" placeholder="请输入平台名称" v-model="search">
            
             </el-input>
              <el-button  style="width: 25%;float: left;margin-left: 2%;" type="primary" icon="el-icon" @click="getSupply">查询</el-button>
              <el-button  style="width: 25%;float: left;margin-left: 2%;background: #999;border: 1px solid #999;" type="primary" icon="el-icon" @click="reast">重置</el-button>
              <div style="clear: both;"></div>
            </el-form-item>
  
        </el-form>  
          
          
        <el-table
              ref="singleTable"
              :data="tableData"
              highlight-current-row
              @current-change="handleCurrentChange"
              border
              style="width: 100%">
              <el-table-column prop="name" label="用户名/姓名">
                <template slot-scope="scope">
                  {{scope.row.user_name}} <br/>
                  {{scope.row.real_name}} <br/>
                </template>
              </el-table-column>
              <el-table-column prop="role.role_name" label="所属角色">
                <template slot-scope="scope">
                  <div v-if="scope.row.is_super == 0">
                    <span class="mr10 green" v-for="(item, index) in scope.row.userRole" :key="index">{{ item.role.role_name }}</span>
                  </div>
                  <div class="gray" v-if="scope.row.is_super == 1">
                    平台
                  </div>
                </template>
              </el-table-column>
            </el-table>
    </div>
      
    

    
    </div>
  </template>
  
  <script>

    import SupplyApi from '@/api/supply.js';
    import AuthApi from '@/api/auth.js';
  
    export default {

      inject: ['reload'],
      data() {
        return {
        
  
  
          search:"",
          tableData:[],
          currentRow :null
        };
      },
      created() {
        this.getSupply();
 
      },
      methods: {
        handleCurrentChange(val) {
    
            this.currentRow = val;
            console.log('val',val);
            this.$emit("handleCurrentChange", { openDialog: false,"id":val.shop_user_id });
      },
      reast() {
    
                this.currentRow = null;
                this.$emit("reast", { openDialog: false,"id":0 });
            },
        getSupply() {

          let self = this;
          let Params = {};
          Params.page = self.curPage;
          Params.list_rows = self.pageSize;
          Params.type = self.type
          Params.user_name = self.search;
          AuthApi.userList(Params, true)
            .then(data => {
              self.loading = false;
              self.tableData = data.data.list.data;
              self.totalDataNumber = data.data.list.total;
            })
            .catch(error => {});
      },
      }
    };
  </script>
  
  <style></style>
  


// WEBPACK FOOTER //
// src/components/select/platform.vue